import styled from 'styled-components'
import { Link } from 'react-router-dom'

export default styled(Link)`
  font-weight: bold;
  font-size: 1.25em;
  padding: 0px 12px 5px 15px;
  margin: 0;
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  color: white;
  text-decoration: none;
`